import { render, staticRenderFns } from "./BillAlert.vue?vue&type=template&id=7dd89b72&scoped=true"
import script from "./BillAlert.vue?vue&type=script&lang=js"
export * from "./BillAlert.vue?vue&type=script&lang=js"
import style0 from "./BillAlert.vue?vue&type=style&index=0&id=7dd89b72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd89b72",
  null
  
)

export default component.exports